<template>
  <div :class="$style.root">
    <LayoutSingleTypeHeadingComponent
      :pageData="pageData"
      routeName="permanent-works"
    />

    <CoreBlocksComponent
      v-if="blocks?.length"
      :blocks="blocks"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  pageData: Object
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData))
})

const blocks = computed(() => {
  return localizedData?.value?.blocks
})
</script>

<style module>
.root {
  display: grid;
  grid-row-gap: var(--unit--vertical--sextuple);
}
</style>
